import { useEffect, useState } from "react";
import {
  PaymentLimitResource,
  CreditorResource,
} from "@gocardless/api/dashboard/types";
import { HTTPError } from "@gocardless/api/utils/api";
import { usePaymentLimitList as usePaymentLimitListQuery } from "@gocardless/api/dashboard/payment-limit/index";

export const usePaymentLimitList = (
  creditorId: CreditorResource["id"],
  limitType: "maximum" | "minimum"
) => {
  const [paymentLimits, setPaymentLimits] = useState<PaymentLimitResource[]>(
    []
  );
  const [error, setError] = useState<HTTPError | null>(null);

  const { data, error: queryError } = usePaymentLimitListQuery({
    creditor: creditorId ?? "",
  });

  useEffect(() => {
    if (queryError) {
      setError(queryError);
    } else if (data?.payment_limits) {
      const paymentLimitsByType = data.payment_limits.filter(
        (payment_limit) => payment_limit.limit_type === limitType
      );
      setPaymentLimits(paymentLimitsByType);
    }
  }, [data, queryError, limitType]);

  return {
    paymentLimits,
    error,
  };
};
